var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoFlechasAvanzar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 933 503",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9983.8 -7965.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.3333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1276.4 955.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 61.122c-2.047 0-4.095-0.781-5.657-2.343-3.124-3.125-3.124-8.189 0-11.314l16.514-16.514-16.514-16.513c-3.124-3.124-3.124-8.189 0-11.313 3.124-3.125 8.19-3.124 11.314-1e-3l27.828 27.827-27.828 27.828c-1.562 1.562-3.61 2.343-5.657 2.343",
    fill: "#989898",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.3333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1241.2 955.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 61.122c-2.047 0-4.095-0.781-5.657-2.343-3.124-3.125-3.124-8.189 0-11.314l16.514-16.514-16.514-16.513c-3.124-3.124-3.124-8.189 0-11.313 3.124-3.125 8.19-3.124 11.314-1e-3l27.828 27.827-27.828 27.828c-1.562 1.562-3.61 2.343-5.657 2.343",
    fill: "#cbcbcb",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.3333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1206 955.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 61.122c-2.047 0-4.095-0.781-5.657-2.343-3.124-3.125-3.124-8.189 0-11.314l16.514-16.514-16.514-16.513c-3.124-3.124-3.124-8.189 0-11.313 3.124-3.125 8.19-3.124 11.314-1e-3l27.828 27.827-27.828 27.828c-1.562 1.562-3.61 2.343-5.657 2.343",
    fill: "#f1f1f1",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoFlechasAvanzar);
export default __webpack_public_path__ + "static/media/icono-flechas-avanzar.d5a6d0dcba609c4d91ca106acb0bd154.svg";
export { ForwardRef as ReactComponent };